(function() {
    // ------------------------------------------------------------------------
    // -------------------------------------------------------------------------
    let openLabels = ['Layout']; 

    $('<style>' +
        '.boost-sd__filter-option-itemwrapper { display: none !important; } ' +
        '.boost-sd__filter-option.is-open > .boost-sd__filter-option-itemwrapper { display: block !important; } ' +
        '.boost-sd__filter-option:first-child:not(.is-closed) > .boost-sd__filter-option-itemwrapper { display: block !important; } ' +
        '.boost-sd__filter-option-title:before { ' +
            'content: ""; border-top-color: transparent !important; border-left-color: currentColor !important; ' +
            'margin: 0 12px 0 0 !important; transition: all 0.2s ease !important; ' +
            'display: inline-block !important; width: 0; height: 0; border: 5px solid rgba(0,0,0,0); ' +
        '} ' +
        '.boost-sd__filter-option.is-open .boost-sd__filter-option-title:before, ' +
        '.boost-sd__filter-option:first-child:not(.is-closed) .boost-sd__filter-option-title:before { ' +
            'border-left-color: transparent !important; border-top-color: currentColor !important; ' +
            'margin: 0 10px -2px 0 !important; ' +
        '} ' +
        '.boost-sd__filter-option.is-closed .boost-sd__filter-option-title:before { ' +
            'border-top-color: transparent !important; border-left-color: currentColor !important; ' +
            'margin: 0 12px 0 0 !important; ' +
        '} ' +
        '.boost-sd__filter-option-icon { display: none !important; } ' +
        '.boost-sd__filter-option-title { cursor: pointer; display: flex; align-items: center; }' +
    '</style>').appendTo('head');

    function applyPersistentStates() {
        $('.boost-sd__filter-option').each(function() {
            var label = $(this).attr('data-label');
            if (openLabels.includes(label)) {
                $(this).addClass('is-open').removeClass('is-closed');
                $(this).find('.boost-sd__filter-option-title').attr('aria-expanded', 'true');
            } else {
                if ($(this).is(':first-child')) {
                    if (!openLabels.includes(label)) {
                        $(this).addClass('is-closed').removeClass('is-open');
                    }
                }
            }
        });
    }

    function initEvents() {
        $(document).off('click', '.boost-sd__filter-option-title').on('click', '.boost-sd__filter-option-title', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            
            var $parent = $(this).closest('.boost-sd__filter-option');
            var label = $parent.attr('data-label');

            if ($parent.hasClass('is-open') || ($parent.is(':first-child') && !$parent.hasClass('is-closed'))) {
                $parent.removeClass('is-open').addClass('is-closed');
                openLabels = openLabels.filter(l => l !== label);
            } else {
                $parent.addClass('is-open').removeClass('is-closed');
                if (!openLabels.includes(label)) {
                    openLabels.push(label);
                }
            }
            applyPersistentStates();
        });
    }

    $(document).ready(function() {
        initEvents();
        applyPersistentStates();

        var observer = new MutationObserver(function() {
            applyPersistentStates();
            initEvents();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
})();

// -------------------------------------------------------------------------
// 2. TABLET FIX - SAME BEHAVIOR ON ALL SCREEN SIZES
// -------------------------------------------------------------------------

var globalFilterScrollTop = 0;

function fixFilterScrollJump() {
    var $list = $('.boost-sd__filter-tree-vertical-option-list');
    if ($list.length > 0) {
        $list.scrollTop(globalFilterScrollTop);
        $list.on('scroll', function() {
            globalFilterScrollTop = $(this).scrollTop();
        });
    }
}

var filterDebounceTimer;
function stopFilterDancing() {
    clearTimeout(filterDebounceTimer);
    filterDebounceTimer = setTimeout(function() {
        fixFilterScrollJump();
    }, 50);
}

// TABLET FORCE FIX - Ensures 'Layout' filter stays open on tablet too
function forceLayoutOpenOnTablet() {
    // Check if tablet (between 768px and 1024px)
    var isTablet = window.innerWidth >= 768 && window.innerWidth <= 1024;
    
    if (isTablet) {
        setTimeout(function() {
            var $layoutFilter = $('.boost-sd__filter-option[data-label="Layout"]');
            if ($layoutFilter.length > 0) {
                // Force open on tablet
                if (!$layoutFilter.hasClass('is-open')) {
                    $layoutFilter.addClass('is-open').removeClass('is-closed');
                    $layoutFilter.find('.boost-sd__filter-option-title').attr('aria-expanded', 'true');
                }
            }
        }, 100); // Small delay to ensure DOM is ready
    }
}

// Run everything - SAFE, doesn't break existing code
$(document).ready(function() {
    // Your original scroll fix
    var scrollObserver = new MutationObserver(function() {
        stopFilterDancing();
        forceLayoutOpenOnTablet(); // Tablet fix added here
    });

    scrollObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Initial tablet check
    forceLayoutOpenOnTablet();
    
    // Check on window resize (when switching between desktop/tablet)
    $(window).on('resize', function() {
        forceLayoutOpenOnTablet();
    });
});